import { useAppSelector } from "../../../../../stateManagement/hooks/redux"

// RoadCategorySegments
export default function RCSContent() {

    const tooltipRoadCategory = useAppSelector(state => state.mapTooltip.roadCategory)
    
    return (
        <>
            <div className="tooltip-info-row">Категория: {tooltipRoadCategory ?? 'Не известна'}</div>
        </>
    )
}
